export const withHeaders = (request, headers)=>{
    if (!headers) {
        return request;
    }
    return (context)=>({
            ...typeof request === 'function' ? request(context) : request,
            headers
        });
};

//# sourceMappingURL=with-headers.js.map